// Reads a config value with this precedence:
//   1. window.__ENV__ (runtime, injected by the container at startup)
//   2. process.env.* (build-time / dev via .env)
//   3. provided fallback
export function getEnv(key, fallback = "") {
  const runtime = (typeof window !== "undefined" && window.__ENV__) || {};
  const rv = runtime[key];
  if (rv !== undefined && rv !== null && String(rv).trim() !== "") return rv;
  const bv = process.env[key];
  if (bv !== undefined && bv !== null && String(bv).trim() !== "") return bv;
  return fallback;
}
